import React from 'react';
import { Link } from 'react-router-dom';
import { ScreenContainer } from '../../CommonComponents';

const NotFound = () => (
  <ScreenContainer>
    <div>
      <h1>404 - Not Found!</h1>
      <Link to="/">Go Home</Link>
    </div>
  </ScreenContainer>
);

export default NotFound;
